import React from 'react';
import { Flame, Shield, Truck, Wrench } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  Flame: Flame,
  Shield: Shield,
  Truck: Truck,
  Wrench: Wrench
};

const BenefitsSection = () => {
  return (
    <section id="benefits" className="py-20 bg-stone-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-amber-500 font-semibold text-sm tracking-wider uppercase">Por que escolher</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-2 mb-4">
            Rotativa <span className="text-amber-500">Gaúcha</span>?
          </h2>
          <p className="text-stone-400 max-w-2xl mx-auto">
            Mais do que churrasqueiras, entregamos tradição, qualidade e a garantia de um churrasco perfeito.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <div
                key={index}
                className="group p-6 bg-stone-900/50 backdrop-blur-sm rounded-2xl border border-stone-700/50 hover:border-amber-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-amber-500/10 text-center"
              >
                <div className="w-14 h-14 bg-amber-500/10 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:bg-amber-500/20 transition-colors">
                  <IconComponent className="w-7 h-7 text-amber-500" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-amber-400 transition-colors">
                  {benefit.title}
                </h3>
                <p className="text-stone-400 text-sm">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { number: '500+', label: 'Clientes Satisfeitos' },
            { number: '10+', label: 'Anos de Experiência' },
            { number: '100%', label: 'Fabricação Própria' },
            { number: 'RS', label: 'Orgulho Gaúcho' }
          ].map((stat, index) => (
            <div key={index} className="text-center p-4">
              <p className="text-3xl md:text-4xl font-bold text-amber-500 mb-1">{stat.number}</p>
              <p className="text-stone-400 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
